import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { IoMdAdd } from 'react-icons/io';
import { useQuery } from '@apollo/client';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import ActionsFormatter from 'components/ActionsFormatter';
import { GET_FAQ_LIST } from 'pages/ApplicationUI/ApplicationUIGraphQL';
import { FSBTable } from 'components/common/FSBTable';
import { FAQColumns } from 'pages/ApplicationUI/components/FAQ/constants';
import { ADD_EDIT_CONSTANT, defaultDeleteFilter } from 'utils/constants';

const FAQDataList = ({
  countryType,
  toggleDeleteRecord,
  searchString,
  handleClickEdit,
}) => {
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'faqCategory',
        value: countryType,
        type: 'STRING',
        op: 'EQ',
      },

      {
        ...defaultDeleteFilter,
      },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
    pagination: true,
  });
  const { data, loading, error, refetch } = useQuery(GET_FAQ_LIST, {
    variables: {
      ...filters,
      filter: [
        ...filters.filter,
        {
          key: 'question',
          value: searchString,
          type: 'STRING',
          op: 'LIKE',
        },
      ],
    },
    fetchPolicy: 'network-only',
  });

  const actionsFormatter = (cell) => {
    return (
      <ActionsFormatter
        isView={false}
        handleDelete={() =>
          toggleDeleteRecord(cell?.row?.original?.id, refetch)
        }
        handleEdit={() =>
          handleClickEdit(cell?.row?.original, ADD_EDIT_CONSTANT.EDIT, refetch)
        }
      />
    );
  };
  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.allFAQs?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  const findIndexOfItem = (item) => {
    return FAQColumns.findIndex((itm) => itm.accessorKey === item);
  };

  FAQColumns[findIndexOfItem('actions')].cell = actionsFormatter;

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.allFAQs?.polystoxFAQs)
    return <NoDataFound message="No Data Found" />;

  return (
    <div>
      <Button
        color="primary"
        className="text-nowrap p-0 position-absolute rounded-btn rounded-circle d-flex align-items-center justify-content-center appui-add-btn"
        size="sm"
        style={{ right: '20px', marginTop: '-51px' }}
        onClick={() => handleClickEdit('', ADD_EDIT_CONSTANT.ADD, refetch)}
      >
        <IoMdAdd color="#fff" size={20} />
      </Button>

      <FSBTable
        data={data?.allFAQs?.polystoxFAQs || []}
        totalCount={data?.allFAQs?.totalCount}
        totalPages={data?.allFAQs?.totalPages}
        columns={FAQColumns}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        keyField="id"
        showSearch={false}
        showFilters
        showDelete={false}
        showPagination
        remote
        tableWraperClass="min-h-table"
        striped={false}
        hover={false}
        bordered={false}
        wrapperClass="table-responsive word-break"
        handlePageChange={handlePageChange}
        onSortChange={onSortChange}
        sorting={sortBy}
        searchPlaceholder="Search Vendors"
      />
    </div>
  );
};

export default FAQDataList;
